import "core-js/modules/es6.object.assign";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var FileExcel = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, Object.assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 16 16"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.61 6H9.496L8 8.204 6.504 6H4.39l2.534 3.788L4.065 14H8v-1.431h-.784L8 11.397 9.741 14h2.194L9.076 9.788 11.61 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 01-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 00.5.5H14v9.75z"
  }));
});
FileExcel.displayName = 'FileExcel';
export var FileExcelDimensions = {
  height: 16,
  width: 16
};